import { makeStyles } from "@mui/styles"

export const useStyles = makeStyles(() => ({
  drawer: {
    flexShrink: 0,
  },
  drawerContent: {
    margin: "0px 37px 20px",
  },
  drawerPaper: {
    bottom: "1px",
    height: "auto !important",
    overflow: "auto",
    position: "fixed !important",
    right: "0 !important",
    top: "116px !important;",
  },
  drawerTitle: {
    color: "#333333",
    fontSize: "16px",
    fontWeight: "bold",
    lineHeight: "24px",
    margin: "0px 37px 20px",
  },
  expandableContainer: {
    "& > span": {
      bottom: "5px",
      position: "relative",
    },

    display: "block !important",
    overflow: "hidden",
    position: "relative",
    textOverflow: "ellipsis",
    width: "314px",
  },
  header: {},
  icon: {
    display: "flex",
    // necessary for content to be below cross icon
    justifyContent: "flex-end",
  },
  listSection: {
    marginBottom: "28px",
  },
  listSectionHeader: {
    color: "#554854",
    fontSize: "14px",
    fontWeight: "bold",
    lineHeight: "20px",
    textTransform: "uppercase",
  },
  listText: {
    alignItems: "baseline",
    color: "#554854",
    display: "flex",
    fontWeight: 400,
    justifyContent: "space-between",
    padding: "8px 0",
  },
  listTextLeft: {
    "& svg": {
      left: "4px",
      position: "relative",
      top: "6px",
    },

    "&:first-letter": {
      textTransform: "uppercase",
    },

    color: "#554854",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "16px",
    marginRight: "2rem",
    whiteSpace: "nowrap",
  },
  listTextRight: {
    color: "#554854",
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "20px",
  },
  notBoldText: {
    fontWeight: 400,
  },
  paperAnchorDockedRight: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  pointerCursor: {
    cursor: "pointer",
    marginRight: "3.5rem",
  },
  root: {
    display: "flex",
  },
}))

export const useDynamicStyles = makeStyles(({ colors }) => ({
  drawer: ({ width }) => ({
    flexShrink: 0,
    width,
  }),
  drawerPaper: ({ height, width }) => ({
    height,
    width,
  }),
  expandableDinamycStyles: ({ expanded }) => ({
    "& > span > span:last-child": {
      display: expanded ? "inline-block" : "inline",
      overflowWrap: expanded ? "anywhere" : "initial",
    },

    height: expanded ? "auto" : "36px",
    lineHeight: expanded ? "auto" : "24px",
    whiteSpace: expanded ? "normal" : "nowrap",
  }),
}))
